module.exports = __webpack_public_path__ + "static/media/my_bag.b3ddf3d1.svg";